( function () {
	'use strict';

	const isPro = window.wlcProData?.isPro || false;

	// Layouts that require Pro on the frontend
	const PRO_LAYOUTS = [ 'classic', 'side-accent', 'card-ribbon' ];

	// ── Pro Overlay injector ──────────────────────────────────────────────────
	function injectProOverlay( wrapper ) {
		// Avoid double-injection
		if ( wrapper.querySelector( '.wlc-pro-overlay' ) ) return;

		const overlay = document.createElement( 'div' );
		overlay.className = 'wlc-pro-overlay';
		overlay.innerHTML = `
			<div class="wlc-pro-overlay__inner">
				<div class="wlc-pro-overlay__icon">⭐</div>
				<div class="wlc-pro-overlay__title">Premium Layout</div>
				<div class="wlc-pro-overlay__desc">This layout is available in the Pro version.</div>
				<a class="wlc-pro-overlay__btn" href="https://checkout.freemius.com/plugin/26895/plan/44542/licenses/1/" target="_blank" rel="noopener noreferrer">
					Buy Now
				</a>
			</div>
		`;

		// Overlay styles injected once
		if ( ! document.getElementById( 'wlc-pro-overlay-styles' ) ) {
			const style = document.createElement( 'style' );
			style.id = 'wlc-pro-overlay-styles';
			style.textContent = `
				.telex-pricing-table-wrapper {
					position: relative;
				}
				.wlc-pro-overlay {
					position: absolute;
					inset: 0;
					z-index: 100;
					display: flex;
					align-items: center;
					justify-content: center;
					background: rgba(10, 8, 25, 0.78);
					backdrop-filter: blur(6px);
					-webkit-backdrop-filter: blur(6px);
					border-radius: 12px;
				}
				.wlc-pro-overlay__inner {
					display: flex;
					flex-direction: column;
					align-items: center;
					gap: 10px;
					text-align: center;
					padding: 32px 40px;
					background: rgba(255,255,255,0.05);
					border: 1px solid rgba(255,255,255,0.12);
					border-radius: 16px;
					max-width: 320px;
					box-shadow: 0 8px 40px rgba(0,0,0,0.4);
				}
				.wlc-pro-overlay__icon {
					font-size: 32px;
					line-height: 1;
					filter: drop-shadow(0 0 8px rgba(255, 210, 0, 0.6));
				}
				.wlc-pro-overlay__title {
					font-size: 18px;
					font-weight: 700;
					color: #ffffff;
					letter-spacing: 0.3px;
				}
				.wlc-pro-overlay__desc {
					font-size: 13px;
					color: rgba(255,255,255,0.65);
					line-height: 1.5;
				}
				.wlc-pro-overlay__btn {
					display: inline-block;
					margin-top: 6px;
					padding: 10px 28px;
					background: linear-gradient(135deg, #f7971e 0%, #ffd200 100%);
					color: #7a4500;
					font-size: 13px;
					font-weight: 700;
					text-decoration: none;
					border-radius: 50px;
					letter-spacing: 0.4px;
					box-shadow: 0 4px 16px rgba(247,151,30,0.45);
					transition: transform 0.2s ease, box-shadow 0.2s ease;
				}
				.wlc-pro-overlay__btn:hover {
					transform: translateY(-2px);
					box-shadow: 0 6px 24px rgba(247,151,30,0.6);
					color: #7a4500;
				}
			`;
			document.head.appendChild( style );
		}

		// Make wrapper relative so overlay positions correctly
		wrapper.style.position = 'relative';
		wrapper.appendChild( overlay );
	}

	// ── Billing toggle logic ──────────────────────────────────────────────────
	function initBillingToggle( wrapper ) {
		var toggleButtons = wrapper.querySelectorAll( '.telex-billing-option' );
		var cards = wrapper.querySelectorAll( '.telex-pricing-card' );

		function switchBilling( billingKey ) {
			toggleButtons.forEach( function ( btn ) {
				btn.classList.remove( 'telex-billing-option--active' );
				if ( btn.getAttribute( 'data-billing' ) === billingKey ) {
					btn.classList.add( 'telex-billing-option--active' );
				}
			} );

			cards.forEach( function ( card ) {
				var pricingRaw = card.getAttribute( 'data-pricing' );
				if ( ! pricingRaw ) return;

				var pricing;
				try {
					pricing = JSON.parse( pricingRaw );
				} catch ( e ) {
					return;
				}

				var data = pricing[ billingKey ];
				if ( ! data ) return;

				var amountEl = card.querySelector( '.telex-pricing-amount' );
				var periodEl = card.querySelector( '.telex-pricing-period' );
				var discountBadge = card.querySelector( '.telex-pricing-discount-badge' );

				if ( amountEl ) {
					amountEl.textContent = data.price || '0';
				}
				if ( periodEl ) {
					periodEl.textContent = data.period || '';
				}
				if ( discountBadge ) {
					if ( data.discount && data.discount !== '' ) {
						discountBadge.textContent = data.discount + '% OFF';
						discountBadge.style.display = '';
					} else {
						discountBadge.style.display = 'none';
					}
				}
			} );
		}

		toggleButtons.forEach( function ( btn ) {
			btn.addEventListener( 'click', function () {
				var billingKey = btn.getAttribute( 'data-billing' );
				switchBilling( billingKey );
			} );
		} );
	}

	// ── Hover class helpers ───────────────────────────────────────────────────
	function initHoverEffects( wrapper ) {
		var cards = wrapper.querySelectorAll( '.telex-pricing-card' );
		cards.forEach( function ( card ) {
			card.addEventListener( 'mouseenter', function () {
				card.classList.add( 'telex-pricing-card--hover' );
			} );
			card.addEventListener( 'mouseleave', function () {
				card.classList.remove( 'telex-pricing-card--hover' );
			} );
		} );
	}

	// ── Main init ─────────────────────────────────────────────────────────────
	document.addEventListener( 'DOMContentLoaded', function () {
		var wrappers = document.querySelectorAll( '.telex-pricing-table-wrapper' );

		wrappers.forEach( function ( wrapper ) {

			// Detect current layout from class, e.g. telex-layout-classic
			var layoutClass = Array.from( wrapper.classList ).find( function ( cls ) {
				return cls.startsWith( 'telex-layout-' );
			} );
			var currentLayout = layoutClass ? layoutClass.replace( 'telex-layout-', '' ) : 'centered';

			// Show Pro overlay on frontend for pro layouts when user is NOT pro
			if ( ! isPro && PRO_LAYOUTS.includes( currentLayout ) ) {
				injectProOverlay( wrapper );
				// Still init billing toggle so the page doesn't break,
				// but the overlay covers the content visually.
			}

			initBillingToggle( wrapper );
			initHoverEffects( wrapper );
		} );
	} );

} )();